import { render, staticRenderFns } from "./exberror.vue?vue&type=template&id=21fe0162&scoped=true"
import script from "./exberror.vue?vue&type=script&lang=js"
export * from "./exberror.vue?vue&type=script&lang=js"
import style0 from "./exberror.vue?vue&type=style&index=0&id=21fe0162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe0162",
  null
  
)

export default component.exports